const styles = theme => ({
  root: {
    position: 'relative',
    marginTop: 10
  },
  svg: {
    display: 'block',
    position: 'absolute',
    left: 0,
    top: 0
  },
  path: {
    opacity: ({ energy }) => energy.animate ? 0 : 1
  },
  content: {
    position: 'relative',
    zIndex: 10,
    padding: [26, 10, 8]
  },
  socialLinks: {
    margin: [0, 'auto', 4],
    maxWidth: 220
  },
  socialLinksItem: {
    padding: 0,
    height: 22,
    fontSize: 22,
    lineHeight: '22px'
  },
  legal: {
    margin: [0, 'auto'],
    padding: 0,
    maxWidth: 400,
    fontSize: 11,
    lineHeight: 1.2
  },

  '@media screen and (min-width: 768px)': {
    root: {
      marginTop: 6
    },
    content: {
      padding: [30, 16, 8]
    },
    socialLinks: {
      marginBottom: 4
    },
    socialLinksItem: {
      height: 22,
      fontSize: 22
    },
    legal: {
      fontSize: 11
    }
  }
});

export { styles };
